import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { 
  XCircleIcon,
  HomeIcon,
  CreditCardIcon,
  ArrowPathIcon
} from '@heroicons/react/24/outline';
import './PaymentFailed.css';

const PaymentFailed: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate('/checkout');
  };

  const handleContactSupport = () => {
    // Navigate to contact page or open support modal
    window.open('mailto:support@example.com', '_blank');
  };

  return (
    <div className="payment-failed-page">
      <div className="container">
        <div className="failed-content">
          {/* Failed Icon */}
          <div className="failed-icon">
            <XCircleIcon className="error-icon" />
          </div>

          {/* Failed Message */}
          <div className="failed-message">
            <h1>{t('paymentFailed.title')}</h1>
            <p className="error-description">
              {t('paymentFailed.description')}
            </p>
            <p className="error-details">
              {t('paymentFailed.details')}
            </p>
          </div>

          {/* Error Details */}
          <div className="error-details-section">
            <h3>{t('paymentFailed.whatWentWrong')}</h3>
            <div className="error-reasons">
              <div className="reason">
                <div className="reason-icon">
                  <CreditCardIcon className="icon" />
                </div>
                <div className="reason-content">
                  <h4>{t('paymentFailed.cardInformation')}</h4>
                  <p>{t('paymentFailed.verifyCardInfo')}</p>
                </div>
              </div>
              
              <div className="reason">
                <div className="reason-icon">
                  <XCircleIcon className="icon" />
                </div>
                <div className="reason-content">
                  <h4>{t('paymentFailed.insufficientFunds')}</h4>
                  <p>{t('paymentFailed.checkBalance')}</p>
                </div>
              </div>
              
              <div className="reason">
                <div className="reason-icon">
                  <ArrowPathIcon className="icon" />
                </div>
                <div className="reason-content">
                  <h4>{t('paymentFailed.networkIssue')}</h4>
                  <p>{t('paymentFailed.connectionProblem')}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="action-buttons">
            <button 
              className="btn btn-primary"
              onClick={handleRetryPayment}
            >
              <ArrowPathIcon className="btn-icon" />
              {t('paymentFailed.tryAgain')}
            </button>
            
            <button 
              className="btn btn-secondary"
              onClick={handleContactSupport}
            >
              {t('paymentFailed.contactSupport')}
            </button>
            
            <Link 
              to="/"
              className="btn btn-outline"
            >
              <HomeIcon className="btn-icon" />
              {t('paymentFailed.backToHome')}
            </Link>
          </div>

          {/* Help Section */}
          <div className="help-section">
            <h4>{t('paymentFailed.needHelp')}</h4>
            <p>
              {t('paymentFailed.contactSupportMessage')}
            </p>
            <div className="contact-info">
              <p><strong>{t('paymentFailed.email')}</strong> support@example.com</p>
              <p><strong>{t('paymentFailed.phone')}</strong> 1-800-123-4567</p>
              <p><strong>{t('paymentFailed.liveChat')}</strong> {t('paymentFailed.available247')}</p>
            </div>
          </div>

          {/* Security Notice */}
          <div className="security-notice">
            <h4>🔒 {t('paymentFailed.securityPriority')}</h4>
            <p>
              {t('paymentFailed.securityMessage')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
